import { subscribeOnce, subscribeObservables } from '@/Infrastructure/KnockoutCustomization/KnockoutUtilities';

export default function applyCustomization() {


    ko.computed.fn.sync = function (target, func) {
        let primary = this;
        let secondary = target;

        subscribeObservables(primary, secondary, func);
    };

    ko.computed.fn.subscribeOnce = subscribeOnce;


};